<!--
 * @Author: your name
 * @Date: 2022-06-17 11
-->
<template>
  <div class="segmentation_row">
    <div class="segmentation"></div>
    <div class="en_title">{{en_title}}</div>
    <div class="ch_title">
      <div class="ch_title_name">{{ch_title_name}}</div>
      <div class="ch_title_img">
        <img src="~@/assets/icon/home/xia.png" alt="">
      </div>
      <div class="ch_title_text">{{ch_title_text}}</div>
    </div>
  </div>
</template>
<script>
export default {
  props:{
    en_title:{
      type:String,
      default:''
    },
    ch_title_name:{
      type:String,
      default:''
    },
    ch_title_text:{
      type:String,
      default:'',
    }
  }
}
</script>
<style lang="scss" scoped>
.segmentation_row{
  padding-top: 6.9333vw;
}
.segmentation{
  width: 12.4vw;
  height: 0.8vw;
  background: #FBCC0A;
  border-radius: 0.4vw;
  margin: 0 auto;
  // margin-top: 6.9333vw;
  
}
.en_title{
  margin-top: 2vw;
  text-align: center;
  font-size: 3.7333vw;
}
.ch_title{
  display: flex;
  justify-content: center;
  align-items: center;
  .ch_title_name{
    font-size: 4.2667vw;
    color: #FBCC0A;
    text-align: center;
  }
  .ch_title_img{
    width: 5%;
    margin: 0px 1.3333vw 0;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .ch_title_text{
    font-size: 4.2667vw;
    color: #000000;
  }
}
</style>